export const en: Record<string, string> = {
  "engagement.active": "In progress",
  "engagement.completed": "Completed",
  "engagement.cancelled": "Cancelled",
  "engagement.worker": "Worker",
  "engagement.employer": "Employer",
  "engagement.youWorker": "You are the worker",
  "engagement.youEmployer": "You are the employer",
  "engagement.progress": "Checklist progress",
  "engagement.done": "done",
  "engagement.message": "Message",
  "engagement.markComplete": "Mark complete",
  "engagement.cancel": "Cancel engagement",
  "engagement.reopen": "Reopen",
  "engagement.checklist": "Work checklist",
  "engagement.empty": "No tasks yet. Add the deliverables or steps you'll track together.",
  "engagement.markUndone": "Mark not done",
  "engagement.markDone": "Mark done",
  "engagement.removeTask": "Remove task",
  "engagement.addTask": "Add a task or deliverable…",
  "bid.submitted": "Submitted",
  "bid.notSelected": "Not selected",
  "bid.revise": "Revise your bid",
  "bid.sealedNotice": "Your price and terms stay sealed from competing bidders",
  "bid.termsExclusions": "Terms & exclusions",
  "bid.documents": "Your documents",
  "bid.yourSealedBid": "Your sealed bid",
  "bid.posted": "Posted",
  "bid.sealedBids": "sealed bids",
  "project.descriptionHeading": "Project description",
  "hiring.mobile.sections": "Hiring sections",
  "hiring.mobile.applicants": "Applicants",
  "hiring.mobile.direct": "Direct offers",
  "hiring.mobile.talent": "Talent pool",
  "hiring.mobile.applied": "Applied",
  "hiring.mobile.shortlisted": "Shortlisted",
  "hiring.mobile.accepted": "Hired",
  "hiring.mobile.rejected": "Rejected",
  "hiring.mobile.pending": "Pending",
  "hiring.mobile.ready": "Ready to fund",
  "hiring.mobile.active": "Active",
  "hiring.mobile.declined": "Declined",
  "hiring.mobile.completed": "Completed",
  "hiring.mobile.cancelled": "Cancelled",
  "hiring.mobile.filters": "Filters",
  "hiring.mobile.status": "Status",
  "hiring.mobile.postedJobs": "Posted job",
  "hiring.mobile.allPostedJobs": "All posted jobs",
  "hiring.mobile.clear": "Clear filters",
  "hiring.mobile.apply": "Apply filters",
  "hiring.mobile.identity": "Verified identity",
  "hiring.mobile.profession": "Verified profession",
  "hiring.mobile.details": "View details",
  "hiring.mobile.close": "Close",
  "hiring.mobile.retry": "Retry",
  "hiring.mobile.loading": "Loading…",
  "hiring.mobile.applicant": "Applicant",
  "hiring.mobile.provider": "Provider",
  "hiring.mobile.noMatches": "No applicants match this status and filters.",
  "hiring.mobile.noJobs": "Post a job to start receiving applicants.",
  "hiring.mobile.noOffers": "No direct offers with this status.",
  "hiring.mobile.appliedFor": "Applied for",
  "hiring.mobile.message": "Application message",
  "hiring.mobile.resume": "Résumé",
  "hiring.mobile.noResume": "Résumé unavailable",
  "hiring.mobile.profile": "View profile",
  "hiring.mobile.shortlist": "Shortlist",
  "hiring.mobile.hire": "Hire",
  "hiring.mobile.reject": "Reject",
  "hiring.mobile.contract": "View contract",
  "hiring.mobile.saved": "Saved",
  "hiring.mobile.inviteJob": "Job to invite",
  "hiring.mobile.invite": "Invite",
  "hiring.mobile.invitedTo": "Invited to",
  "hiring.mobile.unlinked": "This saved entry is not linked to an account.",
  "hiring.mobile.notAccepting": "This member is not accepting job invitations.",
  "hiring.mobile.noOpenJobs": "Post an open job to invite candidates.",
  "hiring.mobile.alreadyApplied": "Already applied to one of your jobs.",
  "hiring.mobile.emptyTalent": "Your talent pool is empty",
  "hiring.mobile.emptyTalentDescription": "Save people from Jobseekers to see them here.",
  "hiring.mobile.browse": "Browse jobseekers",
  "hiring.description": "Review applicants and grow a pool of candidates to invite.",
  "hiring.allJobs": "All jobs",
  "hiring.activeCandidates": "Active candidates",
  "hiring.hired": "Hired",
  "hiring.none": "No applicants yet",
  "hiring.noneDescription": "Once workers apply to your jobs, they'll show up here to review and hire.",
  "hiring.noOneHere": "Nobody here yet",
  "hiring.shortlist": "Shortlist",
  "hiring.hire": "Hire",
  "hiring.reject": "Reject",
  "hiring.notesInterview": "Notes & interview",
  "hiring.trackWork": "Hired — track work",
  "hiring.pipeline": "Pipeline",
  "hiring.talentPool": "Talent Pool",
  "hiring.applied": "Applied",
  "hiring.shortlisted": "Shortlisted",
  "hiring.for": "for",
  "hiring.nobody": "Nobody here yet",
  "hiring.rejectedCount": "applicants rejected (hidden from the board).",
  "rfq.type.label": "RFQ type",
  "rfq.type.select": "Select Services or Items…",
  "rfq.type.services": "Services",
  "rfq.type.items": "Items",
  "rfq.type.unspecified": "Type not specified",
  "rfq.type.required": "Choose Services or Items as the RFQ type.",
  "rfq.type.hint": "Identify what you need quotations for.",
  "activity.apply": "Apply Now",
  "activity.applyAgain": "Apply again",
  "activity.resumeHelp": "Upload a résumé and choose it as active before applying. Your active résumé will be available to the employer with your application.",
  "activity.manageResume": "Add or change résumé",
  "activity.submitBid": "Submit a Bid",
  "activity.submitBidStep": "Submit Bid",
  "activity.placeBid": "Place a Bid",
  "activity.status.shortlisted": "Shortlisted",
  "activity.status.awarded": "Awarded",
};

export const tl: Record<string, string> = {
  "engagement.active": "Kasalukuyang ginagawa",
  "engagement.completed": "Tapos na",
  "engagement.cancelled": "Kinansela",
  "engagement.worker": "Manggagawa",
  "engagement.employer": "Employer",
  "engagement.youWorker": "Ikaw ang manggagawa",
  "engagement.youEmployer": "Ikaw ang employer",
  "engagement.progress": "Progreso ng checklist",
  "engagement.done": "tapos na",
  "engagement.message": "I-message si",
  "engagement.markComplete": "Markahan bilang tapos",
  "engagement.cancel": "Kanselahin ang pakikipagtrabaho",
  "engagement.reopen": "Buksang muli",
  "engagement.checklist": "Checklist ng trabaho",
  "engagement.empty": "Wala pang gawain. Magdagdag ng mga output o hakbang na susubaybayan ninyo nang magkasama.",
  "engagement.markUndone": "Markahan bilang hindi pa tapos",
  "engagement.markDone": "Markahan bilang tapos",
  "engagement.removeTask": "Alisin ang gawain",
  "engagement.addTask": "Magdagdag ng gawain o output…",
  "bid.submitted": "Sinumite",
  "bid.notSelected": "Hindi napili",
  "bid.revise": "Baguhin ang iyong bid",
  "bid.sealedNotice": "Hindi makikita ng ibang bidder ang presyo at mga kondisyon mo.",
  "bid.termsExclusions": "Mga kondisyon at hindi kasama",
  "bid.documents": "Iyong mga dokumento",
  "bid.yourSealedBid": "Iyong selyadong bid",
  "bid.posted": "Na-post",
  "bid.sealedBids": "mga selyadong bid",
  "project.descriptionHeading": "Detalye ng proyekto",
  "hiring.mobile.sections": "Seksyon ng hiring",
  "hiring.mobile.applicants": "Mga aplikante",
  "hiring.mobile.direct": "Direktang alok",
  "hiring.mobile.talent": "Talent pool",
  "hiring.mobile.applied": "Nag-apply",
  "hiring.mobile.shortlisted": "Napili",
  "hiring.mobile.accepted": "Na-hire",
  "hiring.mobile.rejected": "Tinanggihan",
  "hiring.mobile.pending": "Naghihintay",
  "hiring.mobile.ready": "Pondohan na",
  "hiring.mobile.active": "Aktibo",
  "hiring.mobile.declined": "Tinanggihan",
  "hiring.mobile.completed": "Tapos na",
  "hiring.mobile.cancelled": "Kinansela",
  "hiring.mobile.filters": "Salain",
  "hiring.mobile.status": "Status",
  "hiring.mobile.postedJobs": "Inaplayang trabaho",
  "hiring.mobile.allPostedJobs": "Lahat ng trabaho",
  "hiring.mobile.clear": "Alisin ang salaan",
  "hiring.mobile.apply": "Ilapat",
  "hiring.mobile.identity": "Beripikadong identidad",
  "hiring.mobile.profession": "Beripikadong propesyon",
  "hiring.mobile.details": "Tingnan ang detalye",
  "hiring.mobile.close": "Isara",
  "hiring.mobile.retry": "Subukan muli",
  "hiring.mobile.loading": "Naglo-load…",
  "hiring.mobile.applicant": "Aplikante",
  "hiring.mobile.provider": "Tagapagbigay",
  "hiring.mobile.noMatches": "Walang aplikanteng tugma sa status at salaan.",
  "hiring.mobile.noJobs": "Mag-post ng trabaho para makatanggap ng aplikante.",
  "hiring.mobile.noOffers": "Walang direktang alok sa status na ito.",
  "hiring.mobile.appliedFor": "Inaplayang trabaho",
  "hiring.mobile.message": "Mensahe ng aplikante",
  "hiring.mobile.resume": "Résumé",
  "hiring.mobile.noResume": "Walang résumé",
  "hiring.mobile.profile": "Tingnan ang profile",
  "hiring.mobile.shortlist": "Piliin",
  "hiring.mobile.hire": "I-hire",
  "hiring.mobile.reject": "Tanggihan",
  "hiring.mobile.contract": "Tingnan ang kontrata",
  "hiring.mobile.saved": "Na-save",
  "hiring.mobile.inviteJob": "Trabahong iimbitahan",
  "hiring.mobile.invite": "Imbitahan",
  "hiring.mobile.invitedTo": "Inimbitahan sa",
  "hiring.mobile.unlinked": "Walang account na kaugnay ng na-save na ito.",
  "hiring.mobile.notAccepting": "Hindi tumatanggap ng imbitasyon ang miyembrong ito.",
  "hiring.mobile.noOpenJobs": "Mag-post ng bukas na trabaho para makapag-imbita.",
  "hiring.mobile.alreadyApplied": "Nag-apply na sa isa sa mga trabaho mo.",
  "hiring.mobile.emptyTalent": "Wala pang na-save na talento",
  "hiring.mobile.emptyTalentDescription": "Mag-save ng tao mula sa Jobseekers para makita rito.",
  "hiring.mobile.browse": "Tingnan ang jobseekers",
  "hiring.description": "Suriin ang mga aplikante at bumuo ng listahan ng mga kandidatong maaaring imbitahan.",
  "hiring.allJobs": "Lahat ng trabaho",
  "hiring.activeCandidates": "Mga aktibong kandidato",
  "hiring.hired": "Natanggap",
  "hiring.none": "Wala pang aplikante",
  "hiring.noneDescription": "Kapag nag-apply ang mga manggagawa sa trabaho mo, lalabas sila rito para masuri at matanggap.",
  "hiring.noOneHere": "Wala pa rito",
  "hiring.shortlist": "I-shortlist",
  "hiring.hire": "Tanggapin",
  "hiring.reject": "Tanggihan",
  "hiring.notesInterview": "Mga tala at panayam",
  "hiring.trackWork": "Natanggap — subaybayan ang trabaho",
  "hiring.pipeline": "Pipeline",
  "hiring.talentPool": "Pool ng mga Talento",
  "hiring.applied": "Nag-apply",
  "hiring.shortlisted": "Na-shortlist",
  "hiring.for": "para sa",
  "hiring.nobody": "Wala pa rito",
  "hiring.rejectedCount": "aplikanteng tinanggihan (nakatago sa board).",
  "rfq.type.label": "Uri ng RFQ",
  "rfq.type.select": "Pumili ng Serbisyo o Item…",
  "rfq.type.services": "Mga Serbisyo",
  "rfq.type.items": "Mga Item",
  "rfq.type.unspecified": "Hindi tinukoy ang uri",
  "rfq.type.required": "Pumili ng Serbisyo o Item bilang uri ng RFQ.",
  "rfq.type.hint": "Tukuyin kung para saan ang hinihinging sipi ng presyo.",
  "activity.apply": "Mag-apply",
  "activity.applyAgain": "Mag-apply",
  "activity.resumeHelp": "Mag-upload ng résumé at piliin itong aktibo bago mag-apply. Makikita ng employer ang aktibong résumé mo kasama ng aplikasyon.",
  "activity.manageResume": "Magdagdag o magpalit ng résumé",
  "activity.submitBid": "Magsumite ng Bid",
  "activity.submitBidStep": "Magsumite ng Bid",
  "activity.placeBid": "Magsumite ng Bid",
  "activity.status.shortlisted": "Napili sa Shortlist",
  "activity.status.awarded": "Naigawad",
};
